export interface AppVersionInfo {
  latest_version: string;
  // Absent from servers that predate the required-update screen.
  min_version?: string;
  ios_store_url: string;
  android_store_url: string;
}

// Dotted-numeric comparison ("1.0.9" < "1.0.10"). Anything unparseable means
// "don't nudge" — a wrong banner is worse than no banner.
export function isVersionOutdated(installed: string, latest: string): boolean {
  if (!installed || !latest) return false;
  const parse = (v: string) => v.trim().split('.').map((p) => Number.parseInt(p, 10));
  const a = parse(installed);
  const b = parse(latest);
  if (a.some(Number.isNaN) || b.some(Number.isNaN)) return false;
  for (let i = 0; i < Math.max(a.length, b.length); i += 1) {
    const x = a[i] ?? 0;
    const y = b[i] ?? 0;
    if (x !== y) return x < y;
  }
  return false;
}
